import type { ITipsRetentionApiPort } from '@personnel/application/ports/ITipsRetentionApiPort';
import type { UpdateTipsRetentionParamsV3 } from '@personnel/application/dtos/TipsRetentionDto';

/**
 * Use case for updating tips retention (store-level + role-level).
 *
 * @param props.apiPort - Tips retention API port implementation (injected)
 * @returns Use case executor
 */
export const updateTipsRetentionUseCase = (props: { apiPort: ITipsRetentionApiPort }) => {
  const { apiPort } = props;

  const execute = async (params: UpdateTipsRetentionParamsV3): Promise<void> => {
    await apiPort.updateTipsRetention(params);
  };

  return { execute };
};
